export function buildCoachTranscriptReviewRoute(
  transcriptId: string,
  options?: {
    leaderId?: string | null;
    from?: "leaders";
    returnTo?: string | null;
    evidence?: CoachHealthEvidenceRouteIdentity;
  },
) {
  if (options?.evidence) {
    return buildCoachHealthEvidenceRoute("/coach/reviews", options.evidence);
  }
  const params = new URLSearchParams();
  params.set("transcriptId", transcriptId);
  if (options?.leaderId) {
    params.set("leaderId", options.leaderId);
  }
  if (options?.from) {
    params.set("from", options.from);
  }
  if (options?.returnTo) {
    params.set("returnTo", options.returnTo);
  }
  return `/coach/reviews?${params.toString()}`;
}

export function buildCoachLeaderTranscriptReviewRoute(leaderId: string) {
  return `/coach/leaders/${leaderId}?section=transcript-review`;
}
import {
  buildCoachHealthEvidenceRoute,
  type CoachHealthEvidenceRouteIdentity,
} from "@/lib/coachHealth/coachHealthEvidenceRoute";
